module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ae21bd02fff4276409bea90e620da158.png";